import { makeStyles } from "@mui/styles";
import clsx from "clsx";

import { Spacing } from "../../../constants/spacing";
import { AnchoredSheetDefinition } from "./anchoredSheet.definition/anchoredSheet.definition.types";

export const AnchoredSheetContent: AnchoredSheetDefinition["Content"] = ({
  children,
  maxHeight,
  noPadding,
}) => {
  const classes = useStyles();

  return (
    <div
      className={clsx(classes.container, !noPadding && classes.paddedContainer)}
      style={{ maxHeight }}
    >
      {children}
    </div>
  );
};

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    overflow: "auto",
  },
  paddedContainer: {
    padding: `0 ${Spacing.S16}px`,
  },
});
